module.exports = __webpack_public_path__ + "static/media/industria-5.b1898501.jpg";